import React from 'react';
import { Button, Dropdown, Tooltip } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import type { CorrectionContext } from '../hooks/useCorrectionContext';
import {
  CORRECTION_SCENARIO_DROPDOWN_LABELS,
  CORRECTION_SCENARIOS,
  getScenarioBlockedReason,
  isScenarioOperationAllowed,
  type CorrectionScenarioId
} from '../scenarios/correctionScenarioTypes';

type Props = {
  ctx: CorrectionContext;
  selectedScenarioId: CorrectionScenarioId | null;
  onSelectScenario: (id: CorrectionScenarioId) => void;
};

export function CorrectionActionSelector({ ctx, selectedScenarioId, onSelectScenario }: Props) {
  const selectedLabel = selectedScenarioId
    ? CORRECTION_SCENARIO_DROPDOWN_LABELS[selectedScenarioId]
    : 'Выберите действие';

  const menuItems: MenuProps['items'] = CORRECTION_SCENARIOS.map((scenario) => {
    const inDevelopment = scenario.id === 'ADD_CARGO';
    const allowed = !inDevelopment && isScenarioOperationAllowed(ctx, scenario);
    const blockedReason = inDevelopment ? 'В разработке' : getScenarioBlockedReason(ctx, scenario);
    const label = inDevelopment
      ? `${CORRECTION_SCENARIO_DROPDOWN_LABELS[scenario.id]} — В разработке`
      : CORRECTION_SCENARIO_DROPDOWN_LABELS[scenario.id];

    const item = {
      key: scenario.id,
      label: allowed ? label : (
        <Tooltip title={blockedReason ?? undefined}>
          <span style={{ color: 'rgba(0,0,0,0.25)' }}>{label}</span>
        </Tooltip>
      ),
      disabled: !allowed
    };
    return item;
  });

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: ({ key }) => {
          if (key === 'ADD_CARGO') return;
          onSelectScenario(key as CorrectionScenarioId);
        }
      }}
      trigger={['click']}
    >
      <Button>
        Что нужно изменить? <strong style={{ marginLeft: 4 }}>{selectedLabel}</strong>{' '}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
}
